import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Checkbox, ListItemText, MenuItem, Select } from '@mui/material';
import { RECEIVED_WITHIN_OPTIONS } from './billsFilters';
import useStyles from './billsDashboardStyles';

/**
 * One multi-select whose empty state is its own label — untouched it reads "All properties" rather
 * than looking like a control someone forgot to fill in.
 */
const MultiFilter = _ref => {
  let allLabel = _ref.allLabel,
    onChange = _ref.onChange,
    options = _ref.options,
    value = _ref.value,
    attribute = _ref.attribute;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Select, {
    className: classes.toolbarSelect,
    displayEmpty: true,
    multiple: true,
    size: "small",
    value: value,
    onChange: event => onChange(event.target.value),
    MenuProps: {
      PaperProps: {
        className: classes.optionsPaper
      }
    },
    renderValue: selected => selected.length ? selected.join(', ') : /*#__PURE__*/React.createElement("span", {
      className: classes.toolbarSelectPlaceholder
    }, allLabel),
    'custom-attribute': attribute
  }, options.length === 0 ? /*#__PURE__*/React.createElement(MenuItem, {
    disabled: true,
    value: ""
  }, "No options available") : options.map(option => /*#__PURE__*/React.createElement(MenuItem, {
    key: option,
    value: option
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: value.includes(option),
    size: "small"
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: option,
    className: classes.optionLabel
  }))));
};

/**
 * The three filters the PRD puts on the toolbar. Everything else the page can filter on stays in the
 * Filters menu beside them, so no filter has two homes.
 *
 * Received defaults to any time rather than to the PRD's "Last 30 days": defaulting to a window
 * would hide older bills on a page that has always shown all of them, which is a product call rather
 * than a styling one.
 *
 * Rendered as a fragment rather than wrapped in a box of its own: inside a wrapper these three
 * spaced themselves by the wrapper's gap while the search field and the Filters button beside them
 * used the toolbar's, so the row came out 12·8·8·12 and the first select read as misaligned. As
 * siblings they all take the one gap.
 */
export const BillsToolbarFilters = _ref2 => {
  let filters = _ref2.filters,
    onChange = _ref2.onChange,
    options = _ref2.options;
  const classes = useStyles();
  const setFilter = (key, value) => onChange(_objectSpread(_objectSpread({}, filters), {}, {
    [key]: value
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MultiFilter, {
    allLabel: "All properties",
    attribute: "bills-filter-properties",
    onChange: value => setFilter('properties', value),
    options: options.properties,
    value: filters.properties
  }), /*#__PURE__*/React.createElement(MultiFilter, {
    allLabel: "All utilities",
    attribute: "bills-filter-utilities",
    onChange: value => setFilter('utilities', value),
    options: options.utilities,
    value: filters.utilities
  }), /*#__PURE__*/React.createElement(Select, {
    className: classes.toolbarSelect,
    displayEmpty: true,
    size: "small",
    value: filters.receivedWithin,
    onChange: event => setFilter('receivedWithin', event.target.value),
    renderValue: selected => {
      var _RECEIVED_WITHIN_OPTI, _RECEIVED_WITHIN_OPTI2;
      return (_RECEIVED_WITHIN_OPTI = (_RECEIVED_WITHIN_OPTI2 = RECEIVED_WITHIN_OPTIONS.find(option => option.value === selected)) === null || _RECEIVED_WITHIN_OPTI2 === void 0 ? void 0 : _RECEIVED_WITHIN_OPTI2.label) !== null && _RECEIVED_WITHIN_OPTI !== void 0 ? _RECEIVED_WITHIN_OPTI : /*#__PURE__*/React.createElement("span", {
        className: classes.toolbarSelectPlaceholder
      }, "Any time");
    },
    'custom-attribute': 'bills-filter-received'
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, "Any time"), RECEIVED_WITHIN_OPTIONS.map(option => /*#__PURE__*/React.createElement(MenuItem, {
    key: option.value,
    value: option.value
  }, option.label))));
};